/*
 * Action Types
 */
export enum ScheduleTypes {
  LIST_SCHEDULE_REQUEST = '@students/LIST_SCHEDULE_REQUEST',
  LIST_SCHEDULE_SUCCESS = '@students/LIST_SCHEDULE_SUCCESS',
  LIST_SCHEDULE_FAILURE = '@students/LIST_SCHEDULE_FAILURE',

  CREATE_SCHEDULE_REQUEST = '@students/CREATE_SCHEDULE_REQUEST',
  CREATE_SCHEDULE_SUCCESS = '@students/CREATE_SCHEDULE_SUCCESS',
  CREATE_SCHEDULE_FAILURE = '@students/CREATE_SCHEDULE_FAILURE',

  UPDATE_SCHEDULE_REQUEST = '@students/UPDATE_SCHEDULE_REQUEST',
  UPDATE_SCHEDULE_SUCCESS = '@students/UPDATE_SCHEDULE_SUCCESS',
  UPDATE_SCHEDULE_FAILURE = '@students/UPDATE_SCHEDULE_FAILURE',

  DELETE_SCHEDULE_REQUEST = '@students/DELETE_SCHEDULE_REQUEST',
  DELETE_SCHEDULE_SUCCESS = '@students/DELETE_SCHEDULE_SUCCESS',
  DELETE_SCHEDULE_FAILURE = '@students/DELETE_SCHEDULE_FAILURE',
}

export interface ScheduleInterface {
  id: string;
  date: number;
  type: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  month: number;
  year: number;
}

/*
 * State type
 */
export interface ScheduleState {
  readonly scheduleList: ScheduleInterface[];
  readonly loading: boolean;
  readonly error: boolean;
}
